module.exports = __webpack_public_path__ + "img/p1-info.26780c56.jpg";